// TODO: Review in detail what happens here.
export class FrameGenerator {
    constructor(root) {
        if (root.requestAnimationFrame) {
            this._cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this._requestAnimationFrame = root.requestAnimationFrame.bind(root);
        }
        else if (root.mozRequestAnimationFrame) {
            this._cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this._requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        }
        else if (root.webkitRequestAnimationFrame) {
            this._cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this._requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        }
        else if (root.msRequestAnimationFrame) {
            this._cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this._requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        }
        else if (root.oRequestAnimationFrame) {
            this._cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this._requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        }
        else {
            this._cancelAnimationFrame = root.clearTimeout.bind(root);
            this._requestAnimationFrame = (cb) => {
                return root.setTimeout(cb, 1000 / 60);
            };
        }
    }
    get cancelAnimationFrame() {
        return this._cancelAnimationFrame;
    }
    get requestAnimationFrame() {
        return this._requestAnimationFrame;
    }
}
//# sourceMappingURL=FrameGenerator.js.map